import React from "react";
import "./Stages.scss";
import classNames from "classnames";
import { Steps } from "antd";
import {
  UserOutlined,
  LockOutlined,
  ShopOutlined,
  DollarOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";

const { Step } = Steps;

const DEFAULT_STEP_ICONS = [
  <UserOutlined />,
  <LockOutlined />,
  <ShopOutlined />,
  <DollarOutlined />,
  <CreditCardOutlined />,
];

const Stages = ({
  stages,
  currentIndex,
  setCurrentStageIndex,
  missingFields,
  titleStyle = {},
  lineStyle = {},
  className,
  /** אופציונלי: דורס את ברירת המחדל (למשל ללא Lock כשהתשלום זמין) */
  stepIcons,
}) => {
  const icons =
    Array.isArray(stepIcons) && stepIcons.length > 0 ? stepIcons : DEFAULT_STEP_ICONS;

  return (
    <Steps
      className={className}
      current={currentIndex}
      size="small"
      onChange={(index) => {
        if (!stages[index]?.disabled) {
          setCurrentStageIndex(index);
        }
      }}
      responsive={true}
      style={{ marginBottom: className?.includes("agent-register-steps") ? 0 : 32 }}
    >
      {stages.map(({ title, neededFields, disabled }, index) => {
        const hasMissingFields =
          neededFields?.some((field) => missingFields?.includes(field)) ??
          false;

        return (
          <Step
            key={`registration-stage-${index}`}
            title={title}
            icon={icons[index] ?? DEFAULT_STEP_ICONS[index % DEFAULT_STEP_ICONS.length]}
            disabled={disabled}
            status={
              hasMissingFields
                ? "error"
                : index < currentIndex
                  ? "finish"
                  : index === currentIndex
                    ? "process"
                    : "wait"
            }
          />
        );
      })}
    </Steps>
  );
};

export default Stages;
